import { useEffect, useState } from "react"

export function useCopy() {
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (!isCopied) return

    const resetIsCopiedTimeout = setTimeout(() => {
      setIsCopied(false)
    }, 1200)

    return () => clearTimeout(resetIsCopiedTimeout)
  }, [isCopied])

  async function copy(text: string) {
    await navigator.clipboard.writeText(text)
    setIsCopied(true)
  }

  return { isCopied, copy }
}
